// extracted by mini-css-extract-plugin
export default {"group":"LanguageSwitcher_group__SjSiI","btn":"LanguageSwitcher_btn__3qSZn","active":"LanguageSwitcher_active__z3JU-"};